module.exports = __webpack_public_path__ + "static/media/stage_inactive.1234ca70.svg";